import React from 'react';
import ErrorMessage from '../components/ErrorMessage';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import {withStore, withScreenCheck} from '../hoc';

class Error404 extends React.Component {
  static displayName = 'Error404';
  static propTypes = {};
  static defaultProps = {};
  /**
   * @override
   */
  render() {
    console.log('i am here', this.props);
    return (
      <div className="Error404">
        <Navbar {...this.props} />
        <ErrorMessage />
        <Footer {...this.props} />
      </div>
    );
  }
}

export default withStore(withScreenCheck(Error404));



// WEBPACK FOOTER //
// ./src/pages/Error404.js